<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const essayFramework = [
  "Intro paragraph",
  "2-3 body paragraphs",
  "Relevant examples or arguments",
  "Short conclusion",
];

const essayTopics = [
  "My Favourite Personality",
  "Importance of Discipline",
  "My Aim in Life",
  "A Visit to a Historical Place",
];

const essayTips = [
  "Topic se direct related points likho.",
  "Har paragraph me ek clear idea rakho.",
  "Conclusion short aur neat rakho.",
];

const sampleIntro = "Discipline plays a vital role in the life of a student. It teaches obedience, punctuality and self-control.";

const commonMistakes = [
  "Topic se hatt kar extra points likhna.",
  "Ek hi paragraph me poora essay khatam kar dena.",
  "Conclusion skip kar dena ya bohat weak rakhna.",
];

usePageSeo({
  title: "11th Class English Essay | Essay Writing Topics, Format and Tips",
  description: "11th class English essay page with essay framework, common topics, intro example, common mistakes and exam writing tips.",
  keywords: "11th class english essay, class 11 essay writing, english essay topics, essay format 11th class",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
    { name: "Essay", item: "/11th/english/grammar/essay/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Grammar Task"
      title="Essay"
      description="Yeh page essay writing ke liye direct exam-prep support deta hai. Focus structure, topic relevance aur simple expression par hai."
    />

    <EnglishSection title="Essay Framework" description="Use this structure to keep the essay organized and scoring-friendly.">
      <EnglishGrid>
        <EnglishCard v-for="item in essayFramework" :key="item" title="Framework" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Common Essay Topics" description="These are the usual topics students should be ready to handle.">
      <EnglishGrid>
        <EnglishCard v-for="item in essayTopics" :key="item" title="Topic" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Essay Tips" description="Keep these rules in mind while building the answer.">
      <EnglishGrid>
        <EnglishCard v-for="item in essayTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Mini Intro Example" description="A short example showing the tone and clarity expected in the opening paragraph.">
      <EnglishCard title="Sample Intro" :description="sampleIntro" />
    </EnglishSection>

    <EnglishSection title="Common Mistakes" description="Avoid these to keep the essay neat and relevant.">
      <EnglishGrid>
        <EnglishCard v-for="item in commonMistakes" :key="item" title="Mistake" :description="item" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
